/**
 * Hai ứng dụng riêng biệt, đều phục vụ người dùng Việt. Giá trị giữ nguyên chuỗi cũ vì đó là
 * dữ liệu đang lưu, chỉ nhãn hiển thị nói đúng bản chất.
 */
export const APPS = [
    { value: 'vi', label: 'iKara' },
    { value: 'en.yokara', label: 'Yokara' },
];

/** Ứng dụng chọn sẵn ở mọi ô chọn trên trang này. */
export const DEFAULT_APP = 'en.yokara';


export const CONVERSATION_STATUSES = [
    { value: 'NEED_AGENT', label: 'Đang chờ nhân viên' },
    { value: 'BOT_HANDLED', label: 'Chatbot tự lo được' },
    { value: 'RESOLVED', label: 'Đã xử lý xong' },
];

/** Khớp với enum CustomerSupportEscalateReason ở backend. */
export const ESCALATE_REASON_LABELS = {
    LOW_CONFIDENCE: 'Chatbot không đủ chắc chắn',
    MODEL_REQUESTED: 'Chatbot tự nhận không xử lý được',
    SENSITIVE_KEYWORD: 'Câu hỏi thuộc chủ đề nhạy cảm',
    PARSE_ERROR: 'Chatbot trả về nội dung không đọc được',
    LLM_ERROR: 'Gọi mô hình bị lỗi',
    USER_REQUESTED_HUMAN: 'Người dùng đòi gặp nhân viên',
    QUOTA_EXCEEDED: 'Đã chạm trần chi phí trong đêm',
    NO_FAQ_REFERENCE: 'Câu trả lời không dựa trên FAQ nào',
};

export const STATUS_BADGE_CLASS = {
    NEED_AGENT: 'badge badge-danger',
    BOT_HANDLED: 'badge badge-secondary',
    RESOLVED: 'badge badge-success',
};

// Yokara đứng trước để mục mở sẵn khớp với ứng dụng mặc định.
export const PROMPT_IDS = [
    { id: 'customer_support_system_en.yokara', label: 'Nội dung hướng dẫn chatbot — Yokara' },
    { id: 'customer_support_system_vi', label: 'Nội dung hướng dẫn chatbot — iKara' },
    { id: 'customer_support_handover_en.yokara', label: 'Câu chốt chuyển nhân viên — Yokara' },
    { id: 'customer_support_handover_vi', label: 'Câu chốt chuyển nhân viên — iKara' },
];

export const formatDateTime = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('vi-VN');
};
